import React from "react";

const Tutorials = () => {
  return (
    <div className="animate-fadeIn">
      <h1 className="text-center text-4xl p-2 font-bold">Tabla Tutorials</h1>
      <p className="text-center text-lg text-gray-600">
        Explore tutorials for learning tabla, a popular percussion instrument in
        Indian classical music. Whether you're a beginner or an experienced
        player, these tutorials cover various techniques and compositions.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center m-4">
        <div class="relative rounded-lg shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/asx3wwdO178?si=UA-V45TEu4EoFQQ-"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/5l2N8uVKA4k?si=MJI_jljpxfDymL-O"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/Ub1ltSa37KA?si=yUZKMB31096nZfl1"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <h1 className="text-center text-4xl p-2 font-bold">Drums Tutorials</h1>
      <p className="text-center text-lg text-gray-600">
        Discover tutorials for learning drums, covering different styles and
        techniques. Whether you're just starting out or looking to improve your
        skills, these tutorials offer valuable insights and lessons.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center m-4">
        <div class="relative rounded-lg shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/et9hU7QMDYU?si=9sjUlRrSgN-tbrhQ"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/Ez8Q68h9i4M?si=kKdRhsmg_iMrhOaG"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/lql92_54KrQ?si=3AFvDqBZ1yg7sIiH"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <h1 className="text-center text-4xl p-2 font-bold">Guitar Tutorials</h1>
      <p className="text-center text-lg text-gray-600">
        Explore tutorials for learning guitar, from basic chords to advanced
        techniques. Whether you're interested in acoustic or electric guitar,
        these tutorials cover a wide range of topics for all skill levels.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center m-4">
        <div class="relative rounded-lg shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/BBz-Jyr23M4?si=mCIEbUYqcKUm5fMb"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/rTMN8rCBWkw?si=UQDxPA0lCXvHV-Nr"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/qAlyjGrThGo?si=FjHfWWCkvcsBwNQw"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <h1 className="text-center text-4xl p-2 font-bold">Keys Tutorials</h1>
      <p className="text-center text-lg text-gray-600">
        Learn keyboard playing with these tutorials covering various genres and
        playing styles. Whether you're a beginner or an advanced player, you'll
        find helpful lessons and tips to enhance your skills.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center m-4">
        <div class="relative rounded-lg shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/iWbKrq-oEJo?si=1TUtwpQoItYZ73If"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/4SXQ_wlbWog?si=XylgWpYNCzK0UJXF"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="portfolio-box relative rounded-2xl shadow-md overflow-hidden flex">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/bzNKQ2FkEJI?si=1G0urmcEbzrXzxp3"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Tutorials;
